import { Euro, TrendingUp, TrendingDown, AlertTriangle, Wifi } from "lucide-react";

const CHANNEL_LABELS = {
  online: "Online", pos: "POS", whatsapp: "WhatsApp",
  table: "Mesa", aggregator: "Agregador", other: "Outro",
};

const AVG_TICKET_LABELS = {
  unknown: { label: "Desconhecido", color: "text-gray-400 bg-gray-100" },
  low:     { label: "Baixo",        color: "text-amber-700 bg-amber-50" },
  normal:  { label: "Normal",       color: "text-emerald-700 bg-emerald-50" },
  high:    { label: "Alto",         color: "text-blue-700 bg-blue-50" },
};

function SignalBadge({ active, label, icon: Icon, activeColor = "text-emerald-700 bg-emerald-50" }) {
  return (
    <div className={`flex items-center gap-2 px-3 py-2 rounded-lg text-xs font-medium ${
      active ? activeColor : "text-gray-400 bg-gray-50"
    }`}>
      <Icon className="w-3.5 h-3.5 flex-shrink-0" />
      <span>{label}</span>
    </div>
  );
}

export function KarolSalesSignalsSection({ signals }) {
  if (!signals || signals.error) return null;
  const ticket = AVG_TICKET_LABELS[signals.avg_ticket_signal] ?? AVG_TICKET_LABELS.unknown;
  return (
    <div className="space-y-3" data-testid="sales-signals">
      <div className="flex items-center gap-2 px-1">
        <div className="h-px flex-1 bg-gray-100" />
        <span className="text-[10px] font-semibold text-gray-400 uppercase tracking-widest">
          Sinais comerciais
        </span>
        <div className="h-px flex-1 bg-gray-100" />
      </div>
      <div className="grid grid-cols-2 gap-2">
        <SignalBadge
          active={signals.active_sales_signal}
          label="Vendas ativas"
          icon={TrendingUp}
          activeColor="text-emerald-700 bg-emerald-50"
        />
        <SignalBadge
          active={signals.high_abandonment_signal}
          label="Alto abandono"
          icon={AlertTriangle}
          activeColor="text-amber-700 bg-amber-50"
        />
        <SignalBadge
          active={signals.low_paid_conversion_signal}
          label="Conversão baixa"
          icon={TrendingDown}
          activeColor="text-red-700 bg-red-50"
        />
        <div className={`flex items-center gap-2 px-3 py-2 rounded-lg text-xs font-medium ${ticket.color}`}>
          <Euro className="w-3.5 h-3.5 flex-shrink-0" />
          <span>Ticket: {ticket.label}</span>
        </div>
      </div>
      {signals.main_channel_signal && (
        <div className="bg-white rounded-xl border border-gray-100 shadow-sm px-4 py-3 flex items-center gap-3">
          <Wifi className="w-4 h-4 text-gray-400 flex-shrink-0" />
          <span className="text-xs text-gray-400">Canal dominante</span>
          <span className="text-sm font-semibold text-gray-800 ml-auto capitalize">
            {CHANNEL_LABELS[signals.main_channel_signal] ?? signals.main_channel_signal}
          </span>
        </div>
      )}
    </div>
  );
}
